import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-icon',
  imports: [CommonModule],
  templateUrl: './card-icon.component.html',
  styleUrl: './card-icon.component.scss'
})

export class CardIconComponent {
  @Input() description = 'Descrição padrão';
  @Input() svgIcon?: 'file-list' | 'lock' | 'question' | 'authenticity';
}
